import '@rentacenter/racstrap/dist/index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory, History } from 'history';

import './index.scss';

import { App } from './components/app/App';

if (!HTMLElement.prototype.scrollTo) {
  HTMLElement.prototype.scrollTo = function(options: any) {
    this.scrollTop = options?.top || 0;
    this.scrollLeft = options?.left || 0;
  };
}

window.renderDailyActivityPlanner = (containerId: string, history: History) => {
  const elem = document.getElementById(containerId);

  if (elem) {
    ReactDOM.render(<App history={history} />, elem);
  }
};

window.unmountDailyActivityPlanner = (containerId: string) => {
  const elem = document.getElementById(containerId);

  if (elem) {
    ReactDOM.unmountComponentAtNode(elem);
  }
};

if (!window.isRenderedByContainer) {
  import('./bootstrap').then(() => {
    const defaultHistory = createBrowserHistory({
      basename: process.env.PUBLIC_URL
    });

    window.renderDailyActivityPlanner('root', defaultHistory);
  });
}
